export enum AdvertisementTypeEnum {
  LB1 = "lb1",
  IMU1 = "imu1",
  IMU2 = "imu2",
  MIDARTICLESPECIAL = "midarticlespecial",
  PRESTITIAL = "prestitial",
  CATFISH = "catfish",
}

export type AdUnitProps = {
  rootClassName?: string;
  type: AdvertisementTypeEnum;
  slot: string;
  id?: string;
  pubAdTargeting: AdTargetingType[] | AdTargetingType<PageAdTargetValue>[];
  articlePageTarget?: ArticleAdPageTargetingType<string, string>[];
  articleSlotTarget?: ArticleAdSlotTargetingType<string, string>[];
  gsChannels?: string[];
};

export type AdTargetingType<K = string, T = string | string[]> = {
  key: K;
  value: T;
};

export type ArticleAdPageTargetingType<T = string | string[]> = {
  key: string;
  value: T;
};

export type ArticleAdSlotTargetingType<T = string | string[]> = {
  key: string;
  value: T;
};

export type CompanionAdUnitProps = AdUnitProps & {
  adSlotSize: googletag.GeneralSize | undefined;
  pageNumber: string;
};

export type PageAdTargetValue =
  | PageAdTargetingTypeEnum.HOME
  | PageAdTargetingTypeEnum.LISTING
  | PageAdTargetingTypeEnum.TAG
  | PageAdTargetingTypeEnum.ARTICLE;

export enum PageAdTargetingTypeEnum {
  HOME = "home",
  LISTING = "listing",
  TAG = "tag",
  ARTICLE = "article",
}
